import { useMemo } from "react";
import Select from "react-select";

const ReleveFilters = ({
    filters,
    setFilters,
    onSearch,
    tierLabel,
    tiers,
    documentTypes
}) => {
    const tierOptions = useMemo(
        () =>
            tiers.map(tier => ({
                value: tier.id,
                label: tier.name
            })),
        [tiers]
    );
    const handleChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div className="card shadow-sm mb-3">
            <div className="card-body py-3">
                <div className="row g-2 align-items-end">

                    <div className="col-md-2">
                        <div className="d-flex align-items-center gap-2">
                            <label
                                className="mb-0 fw-semibold"
                                style={{ minWidth: "80px" }}
                            >
                                Type
                            </label>

                            <select
                                className="form-control"
                                value={filters.documentType || ""}
                                onChange={e =>
                                    handleChange(
                                        "documentType",
                                        e.target.value
                                    )
                                }
                            >
                                <option value="">Tous</option>

                                {documentTypes.map(type => (
                                    <option
                                        key={type.value}
                                        value={type.value}
                                    >
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>


                    {/* Tier */}
                    <div className="col-md-2">
                        <div className="d-flex align-items-center gap-2">
                            <label
                                className="mb-0 fw-semibold"
                                style={{ minWidth: "60px" }}
                            >
                                Tiers
                            </label>

                            <Select
                                className="flex-grow-1"
                                classNamePrefix="react-select"
                                placeholder="Tous"
                                options={tierOptions}
                                isClearable
                                value={
                                    tierOptions.find(
                                        x => x.value === Number(filters.tierId)
                                    ) || null
                                }
                                onChange={selected =>
                                    handleChange(
                                        "tierId",
                                        selected ? selected.value : ""
                                    )
                                }
                            />
                        </div>
                    </div>

                    {/* Date début */}
                    <div className="col-md-3">
                        <div className="d-flex align-items-center gap-2">
                            <label
                                className="mb-0 fw-semibold"
                                style={{ minWidth: "90px" }}
                            >
                                Du
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                value={filters.dateDebut || ""}
                                onChange={e =>
                                    handleChange("dateDebut", e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* Date fin */}
                    <div className="col-md-3">
                        <div className="d-flex align-items-center gap-2">
                            <label
                                className="mb-0 fw-semibold"
                                style={{ minWidth: "90px" }}
                            >
                                Au
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                value={filters.dateFin || ""}
                                onChange={e =>
                                    handleChange("dateFin", e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* Button */}
                    <div className="col-md-2 text-end">
                        <button
                            className="btn btn-primary w-100"
                            onClick={onSearch}
                        >
                            🔍 Rechercher
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ReleveFilters;